export interface LayoutProps {
    type: string;
    name: string;
    symbol: string;
    strand: string;
    labels: { name: string; data: string }[];
    version: string;
    species: number;
    nicknames: string[];
    descript: { default: string; origin: string };
    mutations: { benign: number; uncertain: number; pathogenic: number; benign_likely: number; pathogenic_likely: number };
    related_ids: { id: string; name: string; href: string }[];

    info: {
        exon: number;
        ncbi: string;
        size: string;
        mutations: number;
        references: number;
        transcripts: number;
        related_models: { id: string; name: string }[];
        related_diseases: number;
        molecular_weight: string;
    };

    chromosome: {
        end: number;
        size: number;
        name: string;
        start: number;
        data: { id: string; end: number; size: number; start: number; stain: string }[];
    };

    attachments: {
        end: number;
        start: number;
        data: { gene_id: number; end: number; name: string; start: number; strand: boolean; target: boolean }[];
    };
}

export const PropsOption = {
    origin: { type: Object as PropType<LayoutProps>, required: true },
} as const;

export type DefaultPropsTypes = ExtractPropTypes<typeof PropsOption>;
